
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:WishlistAutomaticCode:Loaded',function(event) {
     var data = event.detail;
  	event.detail.el[0].append(event.detail.cloneNode[0]);  
  });
  var unique_tracking_number = function(array){
    var outputArray = []; 
    var count = 0; 
    var start = false; 
  
    for (j = 0; j < array.length; j++) { 
      for (k = 0; k < outputArray.length; k++) { 
        if ( array[j] == outputArray[k] ) { 
          start = true; 
        } 
      } 
      count++; 
      if (count == 1 && start == false) { 
        outputArray.push(array[j]); 
      } 
      start = false; 
      count = 0; 
    } 
    return outputArray; 
  
  }
  var flitssetOrderTrack = function(){  
    var a = Flits(".flits-order-list-container .flits-order-card");
    Flits(a).each(function (index,item) {
      var tracking_arr = [];
      var order_page_tarcking = Flits(item).find(".flits-order-tracking");
      var ifAlreadyThere = Flits(item).find(".flits-order-tracking-unique-brekdown .flits-order-tracking-unique-codes .flits-tracking-number-div");
      Flits(order_page_tarcking).each(function (index_i,item_i){
        var track_num = Flits(item_i).attr("data-tracking-number");
        tracking_arr.push(track_num);
      });
      if (tracking_arr.length > 0 && ifAlreadyThere.length == 0){
        var n_res = unique_tracking_number(tracking_arr);
        Flits.each(n_res, function(number,value){
          var tracking_data_attr = Flits('[data-tracking-number="'+value+'"]') 
  
          if (tracking_data_attr.length > 0){         
            var tracking_clone = Flits('[data-tracking-number="'+value+'"]').parent().first().clone();
            tracking_clone.removeClass("flits-hide");    
            Flits(item).find('.flits-order-tracking-unique').removeClass("flits-hide");
            Flits(item).find('.flits-order-tracking-unique-brekdown .flits-order-tracking-unique-codes').append(tracking_clone);
  
          }
        });
      }
    });
  }
  Flits(document).on('Flits:order:Loaded',function(event) {
    setTimeout(function(){
      flitssetOrderTrack();
    }, 3000);
  });
  Flits(document).on('click', '.flits-order-tracking-unique', function() {
    Flits(this).toggleClass('flits-active');
    Flits(this).parents('.flits-order-card').find('.flits-order-tracking-unique-brekdown').slideToggle();
  });
  Flits(document).on('click', '.flits-copy-icon', function () {
    //     flitsAppJquery(this).closest(".flits-row").toast(window.flitsApp.multilang.copy_tracking_number);
    var copyText = Flits(this).closest(".flits-tracking-number-div").find(".flits-order-tracking-hidden-input");
    copyText.select();
    document.execCommand("copy");
    flitsSnackbar.show({
      text: Flits.t('Flits.locals.general.copy_tracking_number', 'Tracking Number Copied.'),
      pos: 'bottom-center',
      showAction: !1,
      customClass: 'flits-alert-default'
    });
  });
  Flits(document).on('Flits:AccountPage:Loaded', function(event){
    setTimeout(function(){
      var points_balance = Flits(".flits-accountpage-sweettooth-points-clone").clone();
      points_balance.removeClass("flits-accountpage-sweettooth-points-clone");
      var points_balance_mobile = Flits(".flits-accountpage-sweettooth-points-clone").clone();
      points_balance_mobile.removeClass("flits-accountpage-sweettooth-points-clone")
      Flits(".flits-desktop-view .flits-greeting-header").append(points_balance);
      Flits(".flits-mobile-account-box .flits-navigation-header").append(points_balance_mobile);
    }, 3000);
  });
  Flits(document).on('Flits:order:pageClick', function(event){
    // Flits('html, body').animate({
    //     scrollTop: Flits(".flits-code-snippet").offset().top - 100
    // }, 1000);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    flitssetOrderTrack();
  });
}(Flits));
